import React from 'react';
import { CONFIG } from '../data/config';
import { WhatsAppIcon } from './WhatsAppIcon';

/**
 * Consulta suelta por WhatsApp. Queda arriba de la barra de confirmar en mobile
 * para no taparla, y baja al borde en desktop (donde no hay barra fija).
 */
export function FabWhatsApp() {
  const href = `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(`Hola! Tengo una consulta sobre ${CONFIG.negocio}.`)}`;
  return <a href={href} target="_blank" rel="noopener" aria-label="Escribinos por WhatsApp" title="Escribinos por WhatsApp" className="fixed bottom-[calc(92px_+_env(safe-area-inset-bottom))] right-4 z-30 grid place-items-center rounded-full bg-[#25D366] text-white shadow-fab transition-transform duration-150 ease-soft hover:scale-105 lg:bottom-6" style={{
    width: 52,
    height: 52
  }} data-id="element-54" data-mp="ae9fdn3quio1">
      <WhatsAppIcon className="h-[27px] w-[27px]" data-id="element-55" data-mp="3noovl7usny9c" />
    </a>;
}